<script>
  export let row = {};
</script>

<div class="filename">{row.filename}</div>
<small>{row.imageurl + (row.inline ? '?inline=1' : '')}</small>

{#if row.metadata.imageinfo}
  <small class="dimensions">{row.metadata.imageinfo.width}x{row.metadata.imageinfo.height}</small>
{/if}

<style lang="scss">
  small {
    color: var(--color-gray-600);
    display: block;
    font-size: var(--font-size-small);
    margin-top: var(--margin-small);
  }

  .dimensions {
    color: var(--color-gray-600);
    display: inline-flex;
    margin-top: var(--margin-small);
  }
</style>
